// @flow
import * as React from "react";
import {injectIntl} from "react-intl";
import {reisy, use} from "reisy";

import type {PositionItem} from "../api/items.js";
import Flow from "../publishables/flow.js";
import Navigation from "../navigation/index.js";
import Heading from '../components/heading';
import {isMobile, isIE, hasPositionStickySupport} from "../environment.js";

const messages = {
	empty: {
		id: "search.empty",
		defaultMessage: "Your search returned no results.",
	}
};

const styles = reisy`
@namespace Search;

JackInTheBox: $Settings.JackInTheBox;

Container {
	@extends Helpers.Fullscreen;

	$Box.box {
		margin: 1.5625em auto;
	}
}
Contain {
	@extends Helpers.Contain;
}

Title {
	margin: 1.6em 0 .15em 0;
	font-family: $Fonts.title;
	font-size: 2.5em;
	text-align: center;
}

isMobile {

}
isDesktop {

}
isIE {
	
}
noPositionStickySupport {

}
`;

type Props = {
	term: string;
	results: Array<PositionItem>;
	intl: any; // TODO: properly type
};

const Search = ({intl: {formatMessage}, term, results}: Props) => (
	<div {...use(styles.Container, styles.JackInTheBox && styles.Contain, isMobile ? styles.isMobile : styles.isDesktop, isIE && styles.isIE, !hasPositionStickySupport && styles.noPositionStickySupport)}>
		<Navigation styles={styles} />
		<Heading lvl={1} {...use(styles.Title)}>{term}</Heading>
		{Flow("tile", formatMessage, results, true, undefined, messages)}
	</div>
);

export default injectIntl(Search);



// WEBPACK FOOTER //
// ./lib/screens/search.js